import { Injectable, SecurityContext } from '@angular/core';
import { USER_TYPES, URLS } from '../constant/constant';
import {
    PromiseResult,
    ErrorModel,
    ServerError
} from '../models/PromiseResult';
import { DomSanitizer } from '@angular/platform-browser';
import { UserLoginOptions } from "./../models/User";
import { SelectItem } from 'primeng';
import { DateUtilService, moment_duration } from './date.util.service';
import { ActivatedRoute, Router } from '@angular/router';
import { WEBSITE_URLS } from '../shared/global';
import { Button_Data } from '../models/util.models';
import { ProviderStateService } from '../services/provider-state.service';


@Injectable({
    providedIn: 'root'
})
export class UtilitiesService {
    readonly userTypes = USER_TYPES;
    readonly urls: WEBSITE_URLS = URLS;
    slug: string = "";
    constructor(
        private readonly sanitizer: DomSanitizer,
        private readonly dateUtil: DateUtilService,
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly providerstateService: ProviderStateService
    ) {
        this.slug = this.providerstateService.getProviderSlug();
    }

    titlecase(label: string) {
        let temp_label;
        let temp_label_words = label.trim().toLowerCase().split(' ');
        for (let i = 0; i < temp_label_words.length; i++) {
            temp_label_words[i] =
                temp_label_words[i][0].toUpperCase() +
                temp_label_words[i].slice(1);
        }
        temp_label = temp_label_words.join(' ');

        return temp_label;
    }

    getBaseUserURL(url: string, index: number): string | undefined {
        if (Boolean(url)) {
            const segments = url.toString().split('/');
            const urlSegment = segments[index];


            if (urlSegment === this.userTypes.DOCTOR) {
                return this.userTypes.DOCTOR;
            } else if (urlSegment === this.userTypes["OTHER-MEDICAL-PROFESSIONALS"]) {
                return this.userTypes["OTHER-MEDICAL-PROFESSIONALS"];
            } else if (urlSegment === this.userTypes.SUPPORT) {
                return this.userTypes.SUPPORT;
            } else if (urlSegment === this.userTypes.VENDOR) {
                return this.userTypes.VENDOR;
            }
        }
        return undefined; // Return undefined if no match found
    }


    timeSince(date: Date) {
        let current = date;
        let today = new Date();
        let seconds = Math.floor((today.getTime() - date.getTime()) / 1000);

        let interval = seconds / 31536000;

        if (interval > 1) {
            return Math.floor(interval) + ' years';
        }
        interval = seconds / 2592000;
        if (interval > 1) {
            return Math.floor(interval) + ' months';
        }
        interval = seconds / 604800;
        if (interval > 1) {
            return Math.floor(interval) + ' weeks';
        }
        interval = seconds / 86400;
        if (interval > 1) {
            return Math.floor(interval) + ' days';
        }
        interval = seconds / 3600;
        if (interval > 1) {
            return Math.floor(interval) + ' hours';
        }
        interval = seconds / 60;
        if (interval > 1) {
            return Math.floor(interval) + ' minutes';
        }
        return Math.floor(seconds) + ' seconds';
    }

    timeStamp(date) {
        let a = this.timeSince(date);
        let b = [];

        if (Number(a.split(' ')[0]) == 1) {
            b.push(String(a.split(' ')[0]));
            b.push(a.split(' ')[1].substring(0, a.split(' ')[1].length - 1));
            return b.join(' ');
        }
        return a;
    }

    resetResponse(
        response: PromiseResult,
        error: ErrorModel,
        server: ServerError
    ): void {
        response = new PromiseResult();
        error = new ErrorModel();
        server = new ServerError();
    }

    dateFormat(date: Date, format: moment_date_format): string {
        return this.dateUtil.dateFormat(date, format);
    }

    getRenderedAmount(raw_amount: number, currency_type: string): string {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency_type
        }).format(raw_amount);
    }
    openWebsiteLinks(base_url_name: string, link: string, target: string): void {
        let url_link = this.sanitizer.sanitize(SecurityContext.URL, this.getBaseUrl(base_url_name) + link)
        if (target == "_self") {
            // window.open(url_link,"_self");
            // window.location.href = url_link;
            window.location.replace(url_link);
            // return false;

        }
        // else if (target === "_blank") {
        //     window.open(url_link, target);
        // }
        else {
            window.open(url_link, target);
        }

    }

    getBaseUrl(base_url_name: string): string {
        return this.urls[base_url_name]
    }

    reloadSessionStorage() {
        if ((sessionStorage.getItem('refresh') === "true")) {
            sessionStorage.removeItem('refresh')
            window.location.reload();
        }
    }

    isRefreshAvialable(): boolean {
        return sessionStorage.getItem('refresh') === "true";
    }

    getMaxDate(): Date {
        return this.dateUtil.subtractQuantity(new Date(), 18, moment_duration.years);
    }

    getLoginOptionsModel(base_url_name: string, url: string, split_index: number) {
        let final_split_index: number
        if (split_index < 0) {
            // /user/login/health-care-professionals/doctor
            final_split_index = url.toString().split('/').length + split_index
        }
        else {
            final_split_index = split_index;
        }
        let doctorSignUpUrl: string = this.getBaseUrl(base_url_name) + 'user/doctor/registration';
        let otherMedicalProfessionalSignUpUrl: string = this.getBaseUrl(base_url_name) + 'user/other-medical-professionals/registration';
        let userLoginOptions: UserLoginOptions = {
            name: "",
            register_url: "",
            base_url: this.getBaseUserURL(url, final_split_index),
            home_back_url: "",
            forget_back_url: "",
        };
        if (userLoginOptions.base_url == this.userTypes["DOCTOR"]) {
            userLoginOptions = {
                name: "Doctor",
                register_url: doctorSignUpUrl,
                base_url: this.getBaseUserURL(url, final_split_index),
                home_back_url: "/",
                forget_back_url: '/user/login/health-care-professionals/' + this.userTypes["DOCTOR"],
            };
        }
        else if (userLoginOptions.base_url == this.userTypes["OTHER-MEDICAL-PROFESSIONALS"]) {
            userLoginOptions = {
                name: "Other Healthcare Provider",
                register_url: otherMedicalProfessionalSignUpUrl,
                base_url: this.getBaseUserURL(url, final_split_index),
                home_back_url: "/",
                forget_back_url: '/user/login/health-care-professionals/' + this.userTypes["OTHER-MEDICAL-PROFESSIONALS"],
            };
        }

        return userLoginOptions;
    }

    getEmptyStringChecker(value: string) {
        return (value != null && Boolean(value) && value?.length > 0);
    }

    getEmptyNumberChecker(value: number) {
        return (value != null && Boolean(value) && value?.toString().length > 0);
    }

    getSelectItemList(data: any[], label: string, value: string, want_null: boolean = false): SelectItem[] {
        let result_selectItem: SelectItem[] = [];
        if (want_null) {
            result_selectItem.push({
                label: "None",
                value: null
            });
        }
        if (typeof data[0] === "object") {
            data.forEach(element => {
                result_selectItem.push(
                    {
                        label: label?.split(".").reduce((o, i) => o[i], element) || element,
                        value: value?.split(".").reduce((o, i) => o[i], element) || element,
                    }
                )
            });
        }
        else {
            data.forEach(element => {
                result_selectItem.push(
                    {
                        label: element,
                        value: element,
                    }
                )
            });
        }
        return result_selectItem;
    }

    findIndexByKeyValueSelectItem(data: SelectItem[], key_name: string, value: string | number | boolean): number {
        return data.findIndex((item, i) => {
            return item.value[key_name] === value;
        });
    }

    findItemByKeyValueSelectItem(data: SelectItem[], key_name: string, value: string | number | boolean): SelectItem {
        var index = this.findIndexByKeyValueSelectItem(data, key_name, value);
        if (index < 0)
            return null;
        return data[index];
    }

    findIndexByKeyValue(data: any[], key_name: string, value: string | number | boolean): number {
        return data.findIndex((item, i) => {
            return this.filter_json(item, key_name) === value;
        });
    }

    findItemByKeyValue(data: any[], key_name: string, value: string | number | boolean): any {
        var index = this.findIndexByKeyValue(data, key_name, value);
        if (index < 0)
            return null;
        return data[index];
    }

    range(start: number, end: number): number[] {
        return Array(end - start + 1).fill(0).map((_, idx) => start + idx)
    }

    filter_json_array(a: any[], json_key_string: string) {
        return a.map((e) => {
            return this.filter_json(e, json_key_string);
        });
    }

    filter_json(a: any, json_key_string: string) {
        return json_key_string.split(".").reduce((o, i) => o[i], a);
    }

    column_array_sum(data_type: string, a: any[], null_value: string, concatenator_value: string) {
        if (data_type == (typeof "")) {
            return a.reduce((r, a) => a.map((b, i) => (r[i] || null_value) + concatenator_value + b), [])
        }
        else if (data_type == (typeof 0)) {
            return a.reduce((r, a) => a.map((b, i) => (r[i] || Number(null_value)) + Number(concatenator_value) + b), [])
        }
    }

    autoresize_textarea(event, id_name: string) {
        let element = document.getElementById(id_name);
        element.setAttribute(
            'style',
            'height:' + element.scrollHeight + 'px;overflow-y:hidden;'
        );
        element.addEventListener('input', this.autoheight, false);
    }

    autoheight(this: HTMLElement) {
        this.style.height = 'auto';
        this.style.height = this.scrollHeight + 'px';
    }

    getImageUrl(defualt_url: string, original_url: string): string {
        let s: string = ""
        if (Boolean(original_url)) {
            s = original_url;
        }
        else {
            s = defualt_url;
        }
        return s;
    }

    RouterNavigation(url: string) {
        this.router.navigate(["/" + this.slug + '/' + url]);
    }

    getResultResponse() {
        let responseResult: PromiseResult = {
            success: null,
            error: null,
            data: null
        };

        return responseResult;
    }

    shallow_copy(a): any {
        return JSON.parse(JSON.stringify(a));
    }

    generate_years_list(start: number, end: number, is_string_value: boolean) {
        let data: SelectItem[] = [];
        if (is_string_value) {
            data = this.getSelectItemList(this.range(start, end).map(String), "", "", false);
        }
        else {
            data = this.getSelectItemList(this.range(start, end).map(Number), "", "", false);
        }
        data.reverse();
        return data;
    }

    async copy_json(o1, o2) {
        //this code is used for copying a json common keys 
        Object.keys(o1).map(async (e) => {

            if (o2.hasOwnProperty(e)) {
                if (typeof o2[e] != "object") {
                    o1[e] = o2[e];
                }
                else if (typeof o2[e] == "object" && o2[e] != null) {
                    await this.copy_json(o1[e], o2[e]);
                }
            }

        });
    }

    getExtension(a: string): string {
        return a.split(".")[1].toLowerCase();
    }

    init_Button_Data(): Button_Data {
        let a: Button_Data = new Button_Data();
        a = {
            is_clicked: false,
            class: "",
            icon: "",
            name: "",

        }
        return a
    }

    isNumericString(input_text: string): boolean {
        for (let i of input_text) {
            if (i < "0" || i > "9")
                return false;
        }
        return true;
    }

}

export enum moment_date_format {
    lll = 'lll',
    LLL = 'LLL',
    LL = 'LL'
}

export function getEnumValues(data: any): any[] {
    return Object.values(data);
}